import React from 'react';
import { useTranslation } from 'react-i18next';
import BubbleButton from '../../../Buttons/BubbleButton/BubbleButton';
import ProfileBanner from './ProfileBanner';
import { ContactMethodsSection, LocationSection, VisaSection } from './ContactSections';
import styles from './ContactPopup.module.css';

/**
 * Contact information display component
 */
const ContactInfoDisplay = ({ talent, onCopy, onClose }) => {
  const { t } = useTranslation();
  
  const hasTalentData = talent && Object.keys(talent).length > 0;
  
  if (!hasTalentData) {
    return (
      <div className={styles.noDataMessage}>
        <p>{t('general.UI.no_data')}</p>
      </div>
    );
  }
  
  return (
    <>
      <div className={styles.contactInfo}>
        <div className={styles.contactHeader}>
          <p className={styles.contactSubtitle}>{t('ContactPopup.contact_subtitle')}</p>
        </div>
        
        <div className={styles.contactFields}>
          {/* Profile Banner */}
          <ProfileBanner talent={talent} />
          
          {/* Contact Methods Section */}
          <ContactMethodsSection 
            talent={talent} 
            onCopy={onCopy} 
            t={t} 
          />
          
          {/* Location Section */}
          <LocationSection 
            talent={talent} 
            t={t} 
          />
          
          {/* Visa Information Section */}
          <VisaSection 
            talent={talent} 
            t={t} 
          />
        </div>
      </div>
      
      <div className={styles.buttons}>
        <BubbleButton 
          onClick={onClose}
          headerButton
        >
          {t('general.UI.close')}
        </BubbleButton>
      </div>
    </>
  );
};

export default ContactInfoDisplay; 